import { HistoricoVeiculoModel } from './../pages/veiculo/historico/model/historico-veiculo.model';
import { ResponseBase } from 'app/interfaces/response-base';
import { Injectable } from '@angular/core';
import { Veiculo } from 'app/models/veiculo/veiculo';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { ModalService } from './modal.service';
import { URL_HELP_API } from 'environments/environment';
import { IsLoadingService } from './is-loading.service';
import { CategoriaVeiculo } from 'app/models/veiculo/categoria-veiculo';
import { CodigoDescricao } from 'app/models/codigo-descricao';
import { Propriedade } from 'app/models/veiculo/propriedade';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class VeiculosService extends BaseService<Veiculo> {

    constructor(
        protected httpClient: HttpClient,
        protected modalService: ModalService,
        protected isLoadingService: IsLoadingService
    ) {
        super(httpClient, modalService, isLoadingService);
    }

    buscarPlaca(placa: string): Promise<ResponseBase<Veiculo>> {
        return new Promise<ResponseBase<Veiculo>>((resolve, reject) => {
            this.get(`${URL_HELP_API.VEICULOS.BUSCA_PLACA}/${placa}`)
                .subscribe(
                    (data: ResponseBase<Veiculo>) => {
                        resolve(data);
                    },
                    err => { this.error(err), reject(err); });
        });
    }

    listarCarrocerias(codigoCategoria: number): Promise<ResponseBase<Array<CodigoDescricao>>> {
        return new Promise<any>((resolve, reject) => {
            this.get(`${URL_HELP_API.VEICULOS.LISTA_CARROCERIAS}/${codigoCategoria}`)
                .subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    err => { this.error(err), reject(err); }
                );
        });
    }

    listarCategorias(): Promise<ResponseBase<Array<CategoriaVeiculo>>> {
        return new Promise<any>((resolve, reject) => {
            this.get(`${URL_HELP_API.VEICULOS.LISTA_CATEGORIAS}`)
                .subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    err => { this.error(err), reject(err); }
                );
        });
    }

    buscarHistorico(placa: string): Promise<ResponseBase<Array<HistoricoVeiculoModel>>> {
        return new Promise<ResponseBase<Array<HistoricoVeiculoModel>>>((resolve, reject) => {
            this.get(`${URL_HELP_API.VEICULOS.BUSCA_HISTORICO}/${placa}`)
                .subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    err => { this.error(err), reject(err); });
        });
    }

    listarMarcas(): Promise<ResponseBase<Array<CodigoDescricao>>> {
        return new Promise<ResponseBase<Array<CodigoDescricao>>>((resolve, reject) => {
            this.get(URL_HELP_API.VEICULOS.LISTA_MARCAS).subscribe(
        (data: any) => resolve(data),
        (err: any) => {
                this.error(err);
                reject(err);
            });
        });
    }

    listarPosses(): Promise<ResponseBase<Array<Propriedade>>> {
        return new Promise<ResponseBase<Array<Propriedade>>>((resolve, reject) => {
            this.get(`${URL_HELP_API.VEICULOS.LISTA_POSSES}`)
                .subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    err => { this.error(err), reject(err); }
                );
        });
    }
}
